<template>
  <div class="shade" ref="shade">
    <div class="center" ref='center'>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { PopupManager } from 'element-ui/lib/utils/popup'

export default {
  name: 'shade',
  mounted(){
    // console.log
      this.$refs.shade.style.zIndex=PopupManager.zIndex+1
      this.$refs.center.style.zIndex=PopupManager.zIndex+1
  }
}
</script>

<style scoped>
.shade {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  /* overflow: hidden; */
  overflow: scroll;
  z-index: 5999;
  display: flex;
}
.shade .center {
    position: relative;
    margin: auto;
    z-index: 3000;
  }
</style>



// WEBPACK FOOTER //
// src/components/shade/shade.vue